import api from '../../plugins/api';

// Смена номера владельца — доступна до начала проверки банком (п.4.2 схемы).
const ffinUpdateOwnerPhone = ({ appealId, mobilePhone }) => {
  return api.patch('/api/bank/ffin/owner', { appealId, mobilePhone });
};

export default ffinUpdateOwnerPhone;
